export const communityInvitationState = {
	PENDING:"PENDING",
	ACCEPTED:"ACCEPTED",
	REJECTED:"REJECTED"
}

export const communityPermisions = {
    contactPermissions: {
        CONTACT_MANAGEMENT: "CONTACT_MANAGEMENT",
        SERVICE_REQUESTS_MANAGEMENT: "SERVICE_REQUESTS_MANAGEMENT",
        ORDERS_MANAGEMENT: "ORDERS_MANAGEMENT"
    }
}